module.exports = __webpack_public_path__ + "static/ABA_2020-Finalist_Newcomer of the Year-206769b7e8ee63ae8aa61ce8c1d285f6.png";